import { BlockStack, Badge, Card, Page, Text } from '@shopify/polaris'

export function CustomerServiceTicketsPage() {
  return (
    <Page title="Tickets" backAction={{ content: 'Customer Service', url: '/workspace/customer-service' }}>
      <BlockStack gap="400">
        <Card>
          <BlockStack gap="300">
            <Text as="h2" variant="headingMd">Tickets</Text>
            <Badge tone="info">Coming soon</Badge>
            <Text as="p" variant="bodySm" tone="subdued">
              Support ticket management — create, assign, and track customer tickets linked to orders.
            </Text>
          </BlockStack>
        </Card>
      </BlockStack>
    </Page>
  )
}
